export const EMOJI_CHOICES:ReadonlyArray<readonly [string,string]> = [
  ['😀','Smile'],['😂','Laugh'],['😊','Happy'],['😍','Love'],['🙃','Upside down'],['😉','Wink'],
  ['🤔','Thinking'],['🤯','Mind blown'],['😭','Tears'],['😈','Mischief'],['👻','Ghost'],['🤖','Robot'],
  ['👾','Invader'],['👀','Eyes'],['✌️','Peace'],['👍','Thumbs up'],['🤘','Rock on'],['💪','Strong'],
  ['🌈','Rainbow'],['🌙','Moon'],['☀️','Sun'],['⚡','Lightning'],['🌻','Sunflower'],['🍄','Mushroom'],
  ['🌵','Cactus'],['🦋','Butterfly'],['🐈','Cat'],['🐸','Frog'],['🦊','Fox'],['🐙','Octopus'],
  ['🍕','Pizza'],['🍒','Cherries'],['🎧','Headphones'],['🎨','Art'],['🚀','Rocket'],['🪩','Disco'],
];

export function parseEmoji(input:string):string {
  const emoji=input.trim().normalize('NFC');
  if(!emoji)throw new Error('Choose one emoji from your keyboard.');
  if([...emoji].length>32)throw new Error('That emoji sequence is too long. Choose one emoji.');
  if(typeof Intl.Segmenter!=='function')throw new Error('This browser cannot read native emoji yet. Choose a saved stamp.');
  const graphemes=[...new Intl.Segmenter(undefined,{granularity:'grapheme'}).segment(emoji)];
  if(graphemes.length!==1)throw new Error('Use one emoji at a time. Skin tones, flags and joined emoji are welcome.');
  if(/^[#*0-9]\uFE0F?\u20E3$/u.test(emoji))return emoji;
  if(/\p{Regional_Indicator}/u.test(emoji)){
    if(!/^\p{Regional_Indicator}{2}$/u.test(emoji))throw new Error('Choose a complete flag emoji.');
    return emoji;
  }
  if(!/[\p{Extended_Pictographic}\p{Emoji_Presentation}]/u.test(emoji)||/^\p{Emoji_Modifier}/u.test(emoji))throw new Error('Choose an emoji rather than letters or numbers.');
  if(emoji.startsWith('\u200D')||emoji.endsWith('\u200D')||![...emoji].every(character=>/[\p{Extended_Pictographic}\p{Emoji_Presentation}\p{Emoji_Modifier}\p{Emoji_Component}\uFE0F\uFE0E\u200D]/u.test(character)))throw new Error('Choose a complete emoji from your keyboard.');
  return emoji;
}

export async function rasterizeEmoji(input:string):Promise<Blob> {
  const emoji=parseEmoji(input);
  const canvas=document.createElement('canvas');canvas.width=256;canvas.height=256;
  const context=canvas.getContext('2d');
  if(!context)throw new Error('This browser could not make the stamp. Try a saved sticker.');
  const font=(size:number)=>`${size}px "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", sans-serif`;
  context.font=font(180);context.textAlign='center';context.textBaseline='alphabetic';
  const initial=context.measureText(emoji);
  const width=initial.actualBoundingBoxLeft+initial.actualBoundingBoxRight||initial.width||180;
  const height=initial.actualBoundingBoxAscent+initial.actualBoundingBoxDescent||180;
  context.font=font(Math.min(210,180*Math.min(208/width,208/height)));
  const metrics=context.measureText(emoji);
  const baseline=(256+metrics.actualBoundingBoxAscent-metrics.actualBoundingBoxDescent)/2;
  context.fillText(emoji,128,Number.isFinite(baseline)?baseline:196);
  if(!context.getImageData(0,0,256,256).data.some((value,index)=>index%4===3&&value>0))throw new Error('That emoji did not render on this device. Try another one.');
  return new Promise((resolve,reject)=>canvas.toBlob(blob=>blob?resolve(blob):reject(new Error('Your emoji could not be saved. Try again.')),'image/png'));
}
